import MiniCard from "../components/MiniCard";
import Title from "../components/Title";

import './styles/techonologyLayout.css'

export default function TechonologyLayout({fadeOut}) {
    return (
        <>
        <div className="spacer presentation-layout" id="technologies">

            <Title fadeOut={fadeOut} content={"Technologies"} />

            <div className={`grid${fadeOut ? " fade-out" : ""}`}>
                <MiniCard displayText={"Html"} icon={"https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/HTML5_Badge.svg/2048px-HTML5_Badge.svg.png"}/>
                <MiniCard displayText={"Css"} icon={"https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/CSS3_logo.svg/800px-CSS3_logo.svg.png"}/>
                <MiniCard displayText={"JavaScript"} icon={"https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/640px-JavaScript-logo.png"}/>
                <MiniCard displayText={"ReactJS"} icon={"https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png"}/>
                <MiniCard displayText={"ViteJS"} icon={"https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Vitejs-logo.svg/1200px-Vitejs-logo.svg.png"}/>
                <MiniCard displayText={"SCSS"} icon={"https://sass-lang.com/assets/img/styleguide/seal-color.png"}/>
                <MiniCard displayText={"Nunjuck"} icon={"https://static-00.iconduck.com/assets.00/file-type-nunjucks-icon-256x256-xfeydtg0.png"}/>
            </div>
        </div>
        </>
    );
};